<template>
    <apexchart height="200" type="area" :options="chartOptions" :series="data"></apexchart>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";

const props = defineProps({
    data: Array,
    color: String,
})

import { useAuthStore } from '@/stores/AuthStore';
const authStore = useAuthStore();

let endColor = ref('#fff');

onMounted(() => {
    if(authStore.user.dark == 1){
        endColor.value = '#2e333d';
    }else {
        endColor.value = '#fff';
    }
});

const chartOptions = ref({
    chart: {
        id: 'publisher_chart',
        toolbar: {
            show: false,
        },
        parentHeightOffset: 0,
    },
    grid: {
        show: false,
    },
    yaxis: {
        labels: {
            formatter: function (value,) {
                return Math.abs(value) > 999
                    ? Math.sign(value) * (Math.abs(value) / 1000).toFixed(1) +
                    "k"
                    : (value == 0 ? '0' : value);
            },
            style: {
                colors: ["#8f8f8f"],
                fontSize: "11px",
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        shared: false,
        x: {
            formatter: function (value) {
                return "Dia " + value;
            },
        },
    },
    xaxis: {
        categories: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
        ],
        labels: {
            style: {
                colors: "#8f8f8f",
                fontSize: "11px",
            },
        },
        axisBorder: {
            show: false,
        },
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 95, 100],
            colorStops: [
            {
                offset: 0,
                color: props.color,
                opacity: 1
            },
            {
                offset: 100,
                color: endColor,
                opacity: 1
            },
        ]
        },
    },
    colors: [props.color],

});
</script>

